import {PUT_EVENTS, actionCreators } from './action';

const initialState = null

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PUT_EVENTS:
      return action.payload 
    default: {
      return state;
    }
  }
};

export default reducer;
